import { Link } from "react-router-dom"

const TERMS_OF_SERVICE = `1. Agreement

These Terms of Service ("Terms") govern your access to and use of Doggy Dynamo, including the personality assessment, dashboard, Ask Dynamo, Story, portraits, email updates, sharing features, and Doggy Dynamo Plus subscription (collectively, the "Service"). By creating an account or using the Service, you agree to these Terms.

2. The Service

Doggy Dynamo helps you understand your dog's personality and apply that insight in daily life. Assessment results, Ask Dynamo answers, tips, perspectives, and portraits are provided for informational and entertainment purposes. They are not veterinary, medical, legal, or professional advice. Always consult a qualified veterinarian or trainer for health, safety, or behavioural emergencies.

3. Eligibility and accounts

You must be at least 16 years old (or the minimum age in your jurisdiction) and able to form a binding contract. You are responsible for maintaining the confidentiality of your login credentials and for activity under your account. Provide accurate account information and notify us promptly of unauthorised use.

4. Your content

You retain ownership of photos, Story entries, Ask Dynamo messages, and other content you submit. You grant Doggy Dynamo a worldwide, non-exclusive licence to host, process, display, and use that content solely to operate and improve the Service, including generating personalised portraits and AI responses.

You must not upload content you do not have rights to use, or content that is unlawful, abusive, or infringes others' rights.

5. Acceptable use

You agree not to:
- misuse, reverse engineer, or disrupt the Service;
- attempt unauthorised access to accounts, systems, or data;
- use the Service to harass, spam, or harm others;
- scrape or automate access except through documented interfaces we provide;
- misrepresent your identity or your dog's identity in a way that harms others.

We may suspend or terminate access for conduct that violates these Terms or creates risk for the Service or other users.

6. Doggy Dynamo Plus and billing

Plus features, pricing, and entitlements are described at checkout and in the Service. Subscriptions renew automatically until cancelled through your account or the billing portal. Fees are processed by Stripe and are non-refundable except where required by law or explicitly stated.

If payment fails, Plus features may be suspended after any grace period shown in your account.

7. Intellectual property

Doggy Dynamo, including its branding, assessment framework, archetype content, software, and design, is owned by us or our licensors. These Terms do not grant you any rights to our trademarks or proprietary content except as needed to use the Service.

8. AI-generated output

Ask Dynamo, portraits, and related features may produce inaccurate, incomplete, or inappropriate output. You are responsible for how you use generated content. Do not rely on AI output as a substitute for professional advice.

9. Disclaimers

THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

10. Limitation of liability

TO THE MAXIMUM EXTENT PERMITTED BY LAW, DOGGY DYNAMO AND ITS OPERATORS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE. OUR TOTAL LIABILITY FOR ANY CLAIM RELATING TO THE SERVICE IS LIMITED TO THE GREATER OF (A) THE AMOUNT YOU PAID US IN THE 12 MONTHS BEFORE THE CLAIM OR (B) £50.

Some jurisdictions do not allow certain limitations; in those cases our liability is limited to the fullest extent permitted by law.

11. Termination

You may stop using the Service at any time and may delete your account from account settings where available. We may suspend or terminate the Service or your account with notice where reasonable, or immediately for serious violations.

12. Changes

We may update these Terms as the product evolves. Continued use after the effective date of updated Terms constitutes acceptance, except where applicable law requires additional consent.

13. Governing law

These Terms are governed by the laws of England and Wales, without regard to conflict-of-law rules. Courts in England and Wales have exclusive jurisdiction, subject to mandatory consumer protections in your country of residence.

14. Contact

Questions about these Terms: legal@doggydynamo.com`

export function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-[var(--color-surface-main)] pb-16">
      <main className="mx-auto max-w-2xl px-4 py-8">
        <p className="text-sm text-[var(--color-text-secondary)]">
          <Link to="/" className="underline">
            Doggy Dynamo
          </Link>
        </p>
        <h1 className="mt-4 text-3xl font-semibold text-[var(--color-text-primary)]">
          Terms of Service
        </h1>
        <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
          Version 1.0 · Effective date: 3 September 2026 · Last updated: 3 September 2026
        </p>
        <div className="mt-6 whitespace-pre-line text-sm leading-relaxed text-[var(--color-text-primary)]">
          {TERMS_OF_SERVICE}
        </div>
      </main>
    </div>
  )
}
